import { render } from "./EnhancedChangelog.vue?vue&type=template&id=4b70325a&scoped=true"
import script from "./EnhancedChangelog.vue?vue&type=script&lang=js"
export * from "./EnhancedChangelog.vue?vue&type=script&lang=js"

import "./EnhancedChangelog.vue?vue&type=style&index=0&id=4b70325a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b70325a"]])

export default __exports__